export function getUnit(unitId) {
  return { path: `units/${unitId}` };
}

export function createUnit(body) {
  return {
    path: 'units',
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function updateUnit(unitId, body) {
  return {
    path: `units/${unitId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function deleteUnit(unitId) {
  return {
    path: `units/${unitId}`,
    method: 'DELETE',
  };
}

export function getTenantsInUnit(unitId, query = '') {
  return unitId
    ? {
      path: `units/${unitId}/tenants${query}`,
    }
    : null;
}

export function getArchivedTenantsInUnit(unitId) {
  return {
    path: `units/${unitId}/tenants/archived`,
  };
}

export function searchBuildingUnits(search, contentType, buildingId) {
  return buildingId
    ? {
      path: `buildings/${buildingId}/units${search}`,
      accept: contentType,
    }
    : null;
}
